const downloadFile = (url: string, filename: string) => {
  fetch(url)
    .then((response) => response.blob()) // Convert the file to a blob
    .then((blob) => {
      const link = document.createElement("a");
      const objectURL = URL.createObjectURL(blob); // Create a URL for the blob
      link.href = objectURL;
      link.download = filename; // Set the filename
      link.click(); // Programmatically click the link to trigger the download
      URL.revokeObjectURL(objectURL); // Clean up the object URL
    })
    .catch((error) =>
      console.error("Error downloading the file:", error.message)
    );
};

export default downloadFile;
